import { useCallback } from 'react';

export const useHighLevelProgramLogic = ({ api, setMaxLevel }) => {
    const handleHighLevelFilter = useCallback((value) => {
        setMaxLevel(value);
    }, []);

    const noDataText =
        api.highLevelProgram.instance.data?.data === null
            ? 'Not applicable with the applied filter'
            : 'No data to display';

    return {
        logic: {
            noDataText,
            handleHighLevelFilter,
        },
    };
};
